import PageTitle from '../../components/page-title'
import { useGetRequiredVersionQuery } from './slice'

import AppConfig from '../../config'

const Dashboard = () => {
  const { data: version } = useGetRequiredVersionQuery(AppConfig.platform)

  return (
    <>
      <PageTitle title="Dashboard" />
      {version && <p>Version: {version.version}</p>}
    </>
  )
}

export default Dashboard
